import { AfterContentInit, ChangeDetectionStrategy, Component, ElementRef, EventEmitter, HostBinding, Input,
         NgModule, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { uniqueId } from '@eui/core';

@Component({
    selector: 'eui-icon-toggle',
    templateUrl: './eui-icon-toggle.component.html',
    styleUrls: ['./styles/_index.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class EuiIconToggleComponent implements AfterContentInit {
    @Input() id: string = `eui-icon-toggle-${uniqueId()}`;
    @Input() styleClass: string;
    @Input() styleClassOn: string = 'eui-u-color-accent-dark';
    @Input() styleClassOff: string = 'eui-u-color-grey-dark';
    @Input() iconClassOff: string;
    @Input() iconClassOn: string;
    @Input() isChecked: boolean = false;
    @Input() isReadOnly: boolean = false;
    @Input() tabindex = 0;
    @Input() ariaLabel = 'Toggle icon';
    @Input() keyboardAccessKey: string;

    @HostBinding('attr.data-e2e') @Input() e2eAttr: string = 'eui-icon-toggle';

    @Output() toggle: EventEmitter<boolean> = new EventEmitter();

    @ViewChild('focusElement') focusElement: ElementRef<HTMLSpanElement>;

    public iconClass: string;
    public stateClass: string;

    ngAfterContentInit() {
        this.setIconClass();
        if (!this.ariaLabel || this.ariaLabel === '') {
            this.ariaLabel = (this.iconClass ? this.iconClass : '');
        }
    }

    onToggle() {
        if (!this.isReadOnly) {
            this.isChecked = !this.isChecked;
            this.setIconClass();
            this.toggle.emit(this.isChecked);
        }
        this.focusElement.nativeElement.focus();
    }

    onKeyDown(event: KeyboardEvent) {
        // tslint:disable-next-line:deprecation
        switch (event.keyCode) {
        case 13: // ENTER
        case 32: // SPACE
            // consume event
            event.preventDefault();
            event.stopPropagation();
            event.cancelBubble = true;
            this.onToggle();
            break;
        }
    }

    private setIconClass() {
        if (this.isChecked) {
            this.iconClass = this.iconClassOn;
            this.stateClass = this.styleClassOn;
        } else {
            this.iconClass = this.iconClassOff;
            this.stateClass = this.styleClassOff;
        }
    }
}

@NgModule({
    imports: [CommonModule],
    exports: [EuiIconToggleComponent],
    declarations: [EuiIconToggleComponent]
})
export class EuiIconToggleComponentModule {
}
